var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prev-button"},[_c('ShadowBox',{staticClass:"shadow-box btn prev",on:{"handleClickShadowBox":_vm.handlePrevBtnClick}},[_c('i',{staticClass:"far fa-chevron-left"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }